// extracted by mini-css-extract-plugin
module.exports = {"paginator":"question_table_paginator_paginator__J4msc"};